import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Section } from 'app/modules/public/master-page/budget-home/sectionmodel';
import { Status } from 'app/modules/public/master-page/budget-home/statusmodel';
import { prices } from 'app/modules/public/master-page/budget-home/pricetourmodel';

@Injectable({
  providedIn: 'root'
})
export class CardHomeService {
  private apiURL = this.baseUrl + 'api/tours';
  isLoading$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,) { }

    getAllSections(): Observable<any> {
      return this.http.get<any>(this.apiURL + '/GetAllSections');
    }

    getAllStatusCards(): Observable<Status[]> {
      return this.http.get<Status[]>(this.apiURL + '/GetAllStatusCard');
    }

    GetACard(model: any):Promise<any>{
      this.isLoading$.next(true);
      return new Promise((resolve, reject) => {
        this.http.post(this.apiURL + '/GetACards', model)
          .subscribe((response: any) => {
            resolve(response.card);
          }, (error) => {
            this.isLoading$.next(false);
            reject(error);
          }, () => {
            this.isLoading$.next(false);
          });
      });
    }

    GetCards(model: any):Promise<any>{
      this.isLoading$.next(true);
     return new Promise((resolve, reject) => {
          this.http.post(this.apiURL + '/getCards', model)
              .subscribe((response: any) => {
                  resolve(response.cards);
              },
                  (error) => {
                      this.isLoading$.next(false);
                      reject(error);
                  },
                  () => {
                      this.isLoading$.next(false);
                  });
        });
    }

    GetCardsServices(model: any):Promise<any>{
      this.isLoading$.next(true);
     return new Promise((resolve, reject) => {
          this.http.post(this.apiURL + '/getCardsServices', model)
              .subscribe((response: any) => {
                  resolve(response);
              },
                  (error) => {
                      this.isLoading$.next(false);
                      reject(error);
                  },
                  () => {
                      this.isLoading$.next(false);
                  });
        });
    }


   GetImages(model: any):Promise<any>{
  this.isLoading$.next(true);
  return new Promise((resolve, reject) => {
    this.http.post(this.apiURL + '/getImages', model)
      .subscribe((response: any) => {
        resolve(response.images);
      }, (error) => {
        this.isLoading$.next(false);
        reject(error);
      }, () => {
        this.isLoading$.next(false);
      });
  });
}

GetStatus(model: any):Promise<any>{
  this.isLoading$.next(true);
  return new Promise((resolve, reject) => {
    this.http.post(this.apiURL + '/getStatus', model)
      .subscribe((response: any) => {
        resolve(response.status);
      }, (error) => {
        this.isLoading$.next(false);
        reject(error);
      }, () => {
        this.isLoading$.next(false);
      });
  });
}


GetPrices(model: any):Promise<any>{
  this.isLoading$.next(true);
  return new Promise((resolve, reject) => {
    this.http.post(this.apiURL + '/getPrices', model)
      .subscribe((response: any) => {
        resolve(response.prices);
      }, (error) => {
        this.isLoading$.next(false);
        reject(error);
      }, () => {
        this.isLoading$.next(false);
      });
  });
}


  
}
